import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuotationAccessoriesComponent } from '../quotation-accessories/quotation-accessories.component';
import { AccessoryDelete } from '../../../shared/models/quotation-model/catalogs/accessory-delete.model';
import { QuotationService } from '../../../shared/services/quotation/quotation.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: true,
  imports: [TranslateModule, MatButtonModule],
})
export class MessageComponent implements OnInit {
  insideItemDelete!: AccessoryDelete;

  constructor(
    public dialogRef: MatDialogRef<QuotationAccessoriesComponent>,
    @Inject(MAT_DIALOG_DATA) public quotationId: any,
    @Inject(MAT_DIALOG_DATA) public accessoryId: any,
    private quotationService: QuotationService,
  ) {}

  ngOnInit(): void {}

  public deleteAccessory(): void {
    this.insideItemDelete = {
      quotationId: this.quotationId.quotationId,
      accessoryId: this.accessoryId.accessoryId,
    };
    this.quotationService.deleteAccessory(this.insideItemDelete).subscribe((response) => {
      this.dialogRef.close();
    });
  }

  public closeModal(): void {
    this.dialogRef.close();
  }
}
